import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import React, { useRef, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

var Modal = function Modal() {
  var _useState = useState(false),
      modalOpened = _useState[0],
      setModalOpened = _useState[1];

  var openModal = function openModal() {
    setModalOpened(true);
  };

  var closeModal = function closeModal() {
    setModalOpened(false);
  };

  var ModalPortal = function ModalPortal(_ref) {
    var children = _ref.children;
    var ref = useRef();

    var _useState2 = useState(false),
        mounted = _useState2[0],
        setMounted = _useState2[1];

    useEffect(function () {
      setMounted(true);

      if (document) {
        var dom = document.querySelector('#root-modal');
        ref.current = dom;
      }
    }, []);

    if (ref.current && mounted && modalOpened) {
      return /*#__PURE__*/createPortal( /*#__PURE__*/_jsxs(_Fragment, {
        children: [children, /*#__PURE__*/_jsx(_JSXStyle, {
          id: "106147968",
          children: ["#__next{overflow:hidden;}"]
        })]
      }), ref.current);
    }

    return null;
  };

  return {
    openModal: openModal,
    closeModal: closeModal,
    ModalPortal: ModalPortal
  };
};

export default Modal;